export const ewsApiRoutesConstants = {
    benchmarkCluster: 'benchmarking/cluster',
    benchmarkRanking: 'benchmarking/ranking',
    benchmarkDeviceCategories: 'benchmarking/device-categories',
    benchmarkOptOut: 'benchmarking/optout',
};
